import React from 'react';
import useApp from '../../store/app/appContext';
import UsersProvider from '../../store/users/usersProvider';
import ClinicsProvider from '../../store/clinics/clinicsProvider';
import PageWrapper from '../../containers/app/PageWrapper';
import PartnersList from '../../containers/partners/PartnersList';

function PartnerManagerPage() {  

  const { appState: { user }} = useApp();

  if (!user) return '';
  if (!user._id) return '';
  
  return (
    <UsersProvider>
      <ClinicsProvider>
        <PageWrapper navbar title='Partner Manager'>
          <PartnersList />
        </PageWrapper>
      </ClinicsProvider>
    </UsersProvider>
  )
}

export default PartnerManagerPage;
